exports.IDS = {
  // IMG_URL: "http://127.0.0.1:8787",

  // IMG_URL: "http://192.168.16.23:8787",

  IMG_URL: "https://omtapovan-node.profcymadev.com:2002",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
